import React from 'react'
import './careers-page-2024.css'
import axios from 'axios'
import { baseUrl } from '../assets/Animations'
import {MdAttachMoney, MdCalendarMonth, MdMusicNote, MdArrowForward, MdStar, MdSend} from 'react-icons/md'
import InputWithLabel from '../DanitComponents/Inputs/InputWithLabel'
import { InstrumentChip } from '../NewStudentForm/AutoFillNewStudentForm/InstrumentChip/InstrumentChip'
import { InputWithInsetLabel } from '../DanitComponents/Inputs/InputWithInsetLabel'
import { Helmet } from 'react-helmet'
import managerPhoto from '../img/courtney_manager.jpg'

const CareersPage2024 = () => {
    const [school, setSchool] = React.useState('')
    const [schools, setSchools] = React.useState([])
    const [instruments, setInstruments] = React.useState([])
    const [playedInstruments, setPlayedInstruments] = React.useState([])
    const [teachingTowns, setTeachingTowns] = React.useState([])
    const [application, setApplication] = React.useState({
        key1app: '',
        key2app: '',
        key3app: '',
        key4app: '',
        key5app: '',
        key6app: '',
        key7app: false,
        key8app: '',
        key9app: '',
        key10app: '',
        key11app: '',
        key12app: '',
        key13app: [],
        key14app: '',
        key15app: '',
        key16app: '',
        key17app: false,
        key18app: false,
        key19app: false,
        key20app: '',
        key21app: false,
        key22app: '',
        id: Math.random().toString(16).slice(2),
      })
    const [submitting, setSubmitting] = React.useState(false)
    const [applicationSubmitted, setApplicationSubmitted] = React.useState(false)
    const myToken = localStorage.getItem('token')
    const myHeader = {headers: { Authorization: `Bearer ${myToken}` }}

    const allBenefits = [
        {title: '🗓️ Flexible Schedule', text: `As a teacher at ${school.name}, you have the unique opportunity to create your own schedule. Enjoy the freedom to balance your professional and personal life while sharing your love for music.`},
        {title: '🎸 Inspire the Future Generation', text: 'Make a lasting impact on the lives of children who are eager to explore the world of music. Be a guiding force in nurturing their passion and witnessing their growth as musicians.'},
        {title: '🚙  Convenient In-Home Lessons', text: 'Say goodbye to the traditional classroom setting! Our teachers have the privilege of conducting weekly private lessons in the comfort of students\' homes. This personalized approach allows for a more engaging and enriching learning experience. (Our teachers claim to appreciate this opportunity to listen to music in the car between lessons 🤘)'},
        {title: '📙  Design Your Curriculum', text: 'We trust our teachers\' experience in creating a lesson plan individualized to each student and their goals. This means you can create a lesson plan for your students that feels organic and matches their needs with your teaching style.'},
        {title: '📈  Advancement Opportunities', text: 'We offer raises based on performance and workload. There is room to grow in your position while also gaining experience in the educational field. '}
    ]

    const standardInputs = [
        {label: 'First Name', placeholder: 'Your first name', value: application.key1app, func: (e) => setApplication((prev) => ({ ...prev, key1app: e.target.value}))},
        {label: 'Last Name', placeholder: 'Your last name', value: application.key2app, func: (e) => setApplication((prev) => ({ ...prev, key2app: e.target.value}))},
        {label: 'Email', placeholder: 'How can we reach you?', value: application.key3app, func: (e) => setApplication((prev) => ({ ...prev, key3app: e.target.value}))},
        {label: 'Phone', placeholder: 'Your phone number', value: application.key4app, func: (e) => setApplication((prev) => ({ ...prev, key4app: e.target.value}))},
        {label: 'City of residence', placeholder: 'Where do you live?', value: application.key5app, func: (e) => setApplication((prev) => ({ ...prev, key5app: e.target.value}))},
    ]

    React.useEffect(() => {
        axios.get(`${baseUrl}/schools`, myHeader)
        .then((res) => {
            setSchools(res.data)
            findTheSchool(res.data)
        })
        .catch((err) => console.log(err))
        getInstruments()
    }, [])

    React.useEffect(() => {
        school !== '' && setApplication((prev) => ({ ...prev, key14app: school.name, key15app: school.email, key16app: `apply@${school.email.split('@')[1]}`}));
    }, [school])

    React.useEffect(() => {
        setApplication((prev) => ({ ...prev, key13app: playedInstruments}))
    }, [playedInstruments])

    React.useEffect(() => {
        let stringOfTownNames = teachingTowns.map((town) => town.name).join(' - ')
        setApplication((prev) => ({ ...prev, key22app: stringOfTownNames}))
    }, [teachingTowns])

    const getInstruments = () => {
        axios.get(`${baseUrl}/inst`)
        .then((res) => {
            let myList = res.data
            myList.sort(compareInstrumentNames)
            setInstruments(myList)
        })
        .catch((err) => console.log(err))
    }

    const compareInstrumentNames = (a, b) => {
        if ( a.name < b.name ) {return -1};
        if ( a.name > b.name ) {return 1};
        return 0;
    }

    const addInstrument = (id) => {
        for(let i = 0; i < instruments.length; i++) {
            if(instruments[i].id === id) {
                //check for duplicates
                for(let j = 0; j < playedInstruments.length; j++) {
                    if(playedInstruments[j].id === id) {
                        document.getElementById('careers-page-2024__select-with-label__actual-select').value = ''
                        return
                    }
                }
                setPlayedInstruments([...playedInstruments, instruments[i]])
            }
        }
        document.getElementById('careers-page-2024__select-with-label__actual-select').value = ''
    }

    const removeInstrument = (id) => {
        let newList = playedInstruments.filter((instrument) => instrument.id !== id)
        setPlayedInstruments(newList)
    }

    const addTown = (id) => {
        for(let i = 0; i < school.towns.length; i++) {
            if(school.towns[i].id === id) {
                //check for duplicates
                for(let j = 0; j < teachingTowns.length; j++) {
                    if(teachingTowns[j].id === id) {
                        document.getElementById('careers-page-2024__select-with-label__actual-select__towns').value = ''
                        return
                    }
                }
                setTeachingTowns([...teachingTowns, school.towns[i]])
            }
        }
        document.getElementById('careers-page-2024__select-with-label__actual-select__towns').value = ''
    }

    const removeTown = (id) => {
        let newList = teachingTowns.filter((town) => town.id !== id)
        setTeachingTowns(newList)
    }

    const scrollDownToApplication = () => {
        let applicationForm = document.getElementById('careers-page-2024__8-section')
        applicationForm.scrollIntoView({behavior: 'smooth'})
    }
    
    const findTheSchool = (data) => {
        let url = window.location.href
        if(url === 'http://localhost:3000/careers') {
            setSchool(data[4])
        } else {
            let trimmed = url.substring(8)
            let name = trimmed.split('.')[0]
            for(let i = 0; i < data.length; i++) {
                if(name === data[i].name.split(' ')[0].toLowerCase()) {
                    setSchool(data[i])
                }
            }
        }
    }

    const submitApplication = () => {
        setSubmitting(true)
        axios.put(`${baseUrl}/newteacherapplication`, {
            application: application
        })
        .then(response => {
            if(response.status === 200) {
                setSubmitting(false)
                setApplicationSubmitted(true)
            } else {
                alert('Sorry! There seems to be a problem. Try submitting your application again.')
            }
        })
        .catch(e => {
            console.log('Oops ' + e)
            console.log(e)
        })
    }


    if(school === '') {
        return <div className='careers-page-2024__loading'>Loading Careers Page...</div>
    }
    return (
        <>
            <Helmet>
                <title>{`${school.name} Careers`}</title>
            </Helmet>
                    <div className='careers-page-2024__wrapper'>
                    <div className='careers-page-2024__top-section'>
                        <div className='careers-page-2024__top-section-hero-image'>
                            <div className='careers-page-2024__welcome'><span className='gradient-text'>Lead</span> the next<br></br> generation of musicians</div>
                            <div className='careers-page-2024__welcome__school-name'>AT {school.name.toUpperCase()}</div>
                        </div>
                        <div className='careers-page__diagonal-divider'></div>
                        <div className='careers-page-2024__top-section-solid-color'>
                            <div className='careers-page-2024__apply-now-button'>
                                <div className='careers-page-2024__apply-now-button__text' onClick={() => scrollDownToApplication()}>Apply Now</div>
                                <MdArrowForward size={18} />
                            </div>
                        </div>
                        <div className='careers-page-2024__benefits-card__wrapper'>
                            <div className='careers-page-2024__benefits-card'>
                                <div className='careers-page-2024__benefits-card__icon'><MdAttachMoney size={36} /></div>
                                <div className='careers-page-2024__benefits-card__text'><span className='gradient-text'>Make money</span> in music</div>
                            </div>
                            <div className='careers-page-2024__benefits-card'>
                                <div className='careers-page-2024__benefits-card__icon'><MdCalendarMonth  size={36} /></div>
                                <div className='careers-page-2024__benefits-card__text'>Build your <span className='gradient-text'>dream schedule</span></div>
                            </div>
                            <div className='careers-page-2024__benefits-card'>
                                <div className='careers-page-2024__benefits-card__icon'><MdMusicNote size={36} /></div>
                                <div className='careers-page-2024__benefits-card__text'>Be somebody's <span className='gradient-text'>role model</span></div>
                            </div>
                        </div>
                        <div className='careers-page__diagonal-divider__white'></div>
                        {/* <div className="careers-page-2024__logo" style={{backgroundImage: `url(${school.logoUrl})`}}></div> */}
                    </div>
                    <div className='careers-page-2024__2-section'>
                        <div className='careers-page-2024__h1'>🎻 We need amazing musicians like you 🎹</div>
                            <div className='careers-page-2024__h2'>In-home music lessons in and around {school.city}, {school.state}.</div>
                        <div className='careers-page-2024__paragraph'>At {school.name}, we believe in more than just hitting the right chords. We believe in striking a harmonious balance between technical proficiency and individual expression. Our commitment to an individualized approach ensures that each student receives tailored guidance, recognizing their unique needs, and embracing diverse learning styles.</div>
                        <div className='careers-page-2024__paragraph'>Joining our team means being part of an inspiring community that goes beyond teaching notes and scales. It's about creating an environment where students, guided by our passionate instructors, can find their voice, build confidence, and embark on their musical journey with joy.</div>
                        <div className='careers-page-2024__paragraph'>What sets us apart is not just the quality of our lessons but the transformative moments we witness – from the shy beginner taking their first steps to the seasoned musician landing lead roles in school productions. We celebrate not just the music, but the stories it creates.</div>
                        <div className='careers-page-2024__paragraph'>If you're driven by a love for music, a commitment to excellence, and a desire to be part of a team that makes a real impact, {school.name} is the stage where your career can hit all the right notes. Come join us and be part of a symphony of success, where every role contributes to the beautiful melody of our students' growth and achievement.</div>
                        <div className='careers-page-2024__apply-now-button'>
                            <div className='careers-page-2024__apply-now-button__text' onClick={() => scrollDownToApplication()}>Apply Now</div>
                            <MdArrowForward size={18} />
                        </div>
                    </div>
                    <div className='careers-page__diagonal-divider'></div>
                    {school.careersPage.testimonials.length > 0 && <div className='careers-page-2024__3-section'>
                        <div className='careers-page-2024__3-section__title'>What our teachers have to say...</div>
                        {school.careersPage.testimonials.map((testimonial, index) => 
                        index % 2 === 0 ?
                            <div className='careers-page-2024__3-section__quote-wrapper'>
                                <img className='careers-page-2024__3-section__quote-image' alt='teacher' src={testimonial.teacherImage} />
                                <div className='careers-page-2024__3-section__quote'>
                                    <div className='careers-page-2024__3-section__quote__text'>{testimonial.quote}</div>
                                    <div className='careers-page-2024__3-section__quote__bottom-section'>
                                        <div className='careers-page-2024__3-section__quote__bottom-section__teacher'>
                                            <div className='careers-page-2024__3-section__quote__author'>{testimonial.teacherName}</div>
                                            <div className='careers-page-2024__3-section__quote__instruments'>{testimonial.instruments}</div>
                                        </div>
                                        <a href={testimonial.articleLink} target='_blank' rel="noreferrer" className='careers-page-2024__3-section__quote__link'>Read Interview</a>
                                    </div>
                                </div>
                            </div>
                        :
                        <div className='careers-page-2024__3-section__quote-wrapper'>
                        <div className='careers-page-2024__3-section__quote'>
                            <div className='careers-page-2024__3-section__quote__text'>{testimonial.quote}</div>
                            <div className='careers-page-2024__3-section__quote__bottom-section'>
                                <div className='careers-page-2024__3-section__quote__bottom-section__teacher'>
                                    <div className='careers-page-2024__3-section__quote__author'>{testimonial.teacherName}</div>
                                    <div className='careers-page-2024__3-section__quote__instruments'>{testimonial.instruments}</div>
                                </div>
                                <a href={testimonial.articleLink} target='_blank' rel="noreferrer" className='careers-page-2024__3-section__quote__link'>Read Interview</a>
                            </div>
                        </div>
                        <img className='careers-page-2024__3-section__quote-image-right' alt='teacher' src={testimonial.teacherImage} />
                    </div>
                        )}
                    </div>}
                    <div className='careers-page__diagonal-divider__white'></div>
                    <div className='careers-page-2024__4-section'>
                        <div className='careers-page-2024__4-section__title'>Responsibilities:</div>
                        <ul className='careers-page-2024__4-section__list'>
                            <li>Conduct weekly private music lessons in the homes of students.</li>
                            <li>Serve the vibrant community of {school.city}, {school.state} and surrounding towns.</li>
                            <li>Foster a positive and encouraging learning environment for students of all ages.</li>
                            <li>Develop curriculum and adjust it to students needs </li>
                            <li>Maintain a high level of professionalism and reliability.</li>
                            <li>Hold yearly recitals for your students</li>
                            <li>Must have a degree in music or actively be working toward one.</li>
                            <li>Possess a reliable vehicle for transportation to students' homes.</li>
                        </ul>
                        <div className='careers-page-2024__apply-now-button'>
                            <div className='careers-page-2024__apply-now-button__text' onClick={() => scrollDownToApplication()}>Apply Now</div>
                            <MdArrowForward size={18} />
                        </div>
                    </div>
                    <div className='careers-page__diagonal-divider'></div>
                    <div className='careers-page-2024__5-section'>
                        <div className='careers-page-2024__5-section__title'>Benefits:</div>
                        {allBenefits.map((benefit, index) => {
                            return (
                                <div key={index} className='careers-page-2024__5-section__benefit-wrapper'>
                                    <div className='careers-page-2024__5-section__benefit-title'>{benefit.title}</div>
                                    <div className='careers-page-2024__5-section__benefit-text'>{benefit.text}</div>
                                </div>
                            )
                        })}
                        <div className='careers-page-2024__apply-now-button'>
                            <div className='careers-page-2024__apply-now-button__text' onClick={() => scrollDownToApplication()}>Apply Now</div>
                            <MdArrowForward size={18} />
                        </div>
                    </div>
                    <div className='careers-page__diagonal-divider__white'></div>
                    <div className='careers-page-2024__6-section'>
                        <div className='careers-page-2024__6-section__text-wrapper'>
                            <div className='careers-page-2024__6-section__meet-your-manager'><span className='gradient-text'>MEET THE MANAGER</span></div>
                            <div className='careers-page-2024__6-section__manager-title'>Greetings! I'm Courtney,</div>
                            <div className='careers-page-2024__6-section__manager-text'>the dedicated manager of {school.name} for the past two years. My enthusiasm lies in fostering meaningful connections between talented teachers and eager students. I am committed to creating an environment where passion meets purpose, fostering a community where musicians thrive and students flourish in their pursuit of music passions. Join me in making a difference in the world of music education!</div>
                        </div>
                        <img className='careers-page-2024__6-section__manager-picture' alt='manager' src={managerPhoto} />
                    </div>
                    <div className='careers-page__diagonal-divider'></div>
                    <div className='careers-page-2024__7-section'>
                        <div className='careers-page-2024__7-section__review-wrapper'>
                            <div className='careers-page-2024__7-section__review-text'>...thank you {school.name} for giving us a beautiful group of professionals. </div>
                            <div>
                                <MdStar style={{margin: "20px 10px"}} color='#FFE67D' size={24} />
                                <MdStar style={{margin: "20px 10px"}} color='#FFE67D' size={24} />
                                <MdStar style={{margin: "20px 10px"}} color='#FFE67D' size={24} />
                                <MdStar style={{margin: "20px 10px"}} color='#FFE67D' size={24} />
                                <MdStar style={{margin: "20px 10px"}} color='#FFE67D' size={24} />
                            </div>
                            <div className='careers-page-2024__7-section__reviewer'>ANITA</div>
                            <div className='careers-page-2024__7-section__location'>{school.city}, {school.state}</div>
                        </div>
                    </div>
                    <div className='careers-page__diagonal-divider__white'></div>
                    <div className='careers-page-2024__8-section' id="careers-page-2024__8-section">
                        <div className='careers-page-2024__8-section__title'>Apply to {school.name}</div>
                        <div className='careers-page-2024__8-section__application-form__wrapper'>
                            {standardInputs.map((input, index) => {
                                return (
                                    <div key={index} className='careers-page-2024__input-wrapper'>
                                        <InputWithInsetLabel label={input.label} placeholder={input.placeholder} value={input.value} changeFunction={input.func} />
                                    </div>
                                )
                            })}
                            <div className='careers-page-2024__input-wrapper'>
                                <div className='careers-page-2024__dropdown-label'>Ideal Studio Size</div>
                                <select className='careers-page-2024__select-with-label__actual-select' name="selectInput2" value={application.key9app} onChange={(e) => setApplication((prev) => ({...prev, key9app: e.target.value}))} >
                                    <option value="">How many students are you dreaming of?</option>
                                        <option value='1-5'>1-5 Students</option>
                                        <option value='5-10'>5-10 Students</option>
                                        <option value='10-15'>10-15 Students</option>
                                        <option value='15-20'>15-20 Students</option>
                                        <option value='20-25'>20-25 Students</option>
                                </select>
                            </div>
                            <div className='careers-page-2024__input-wrapper'>
                                <div className='careers-page-2024__dropdown-label'>Experience Level</div>
                                <select className='careers-page-2024__select-with-label__actual-select' name="selectInput2" value={application.key6app} onChange={(e) => setApplication((prev) => ({...prev, key6app: e.target.value}))}>
                                    <option value="">How many years have you been teaching?</option>
                                    <option value='1'>1 years</option>
                                    <option value='2'>2 years</option>
                                    <option value='3'>3 years</option>
                                    <option value='4'>4 years</option>
                                    <option value='+5'>+5 years</option>
                                </select>
                            </div>
                            <div className='careers-page-2024__input-wrapper'>
                                <div className='careers-page-2024__dropdown-label'>Instrument(s)</div>
                                <select className='careers-page-2024__select-with-label__actual-select' id='careers-page-2024__select-with-label__actual-select' name="selectInput1" onChange={(e) => addInstrument(e.target.value)} >
                                    <option value="">{playedInstruments?.length > 0 ? 'Add another instrument' : 'Choose an instrument'}</option>
                                    {instruments.map((instrument) => (
                                        <option key={instrument.id} value={instrument.id}>{instrument.name}</option>
                                    ))}
                                </select>
                                {playedInstruments?.length > 0 ? (
                                    <div>
                                        {playedInstruments?.map((instrument) => (
                                            <InstrumentChip key={instrument.id} instrument={instrument} onClick={() => removeInstrument(instrument.id)} />
                                        ))}
                                    </div>
                                )
                                :
                                    <p className='auto-fill-new-student-form__page__each-input__error-message'>Please select an instrument</p>
                                }
                            </div>
                            <div className='careers-page-2024__input-wrapper'>
                            <div className='careers-page-2024__dropdown-label'>Areas You Are Willing to Service</div>
                                <select className='careers-page-2024__select-with-label__actual-select' id='careers-page-2024__select-with-label__actual-select__towns' name="selectInput1" onChange={(e) => addTown(e.target.value)} >
                                    <option value="">{teachingTowns?.length > 0 ? 'Add another town' : 'Add a town'}</option>
                                    {school.towns.map((town) => (
                                        <option key={town.id} value={town.id}>{town.name}</option>
                                    ))}
                                </select>
                                {teachingTowns?.length > 0 ? (
                                    <div>
                                        {teachingTowns?.map((town) => (
                                            <InstrumentChip key={town.id} instrument={town} onClick={() => removeTown(town.id)} />
                                        ))}
                                    </div>
                                )
                                :
                                    <p className='auto-fill-new-student-form__page__each-input__error-message'>Please select an location</p>
                                }
                            </div>
                            <div className='careers-page-2024__text-field-wrapper'>
                                <div className='careers-page-2024__text-field-label'>COVER LETTER</div>
                                <textarea className='careers-page-2024__text-field' placeholder='Why are you a great fit for our school?' value={application.key10app} onChange={(e) => {setApplication((prev) => ({ ...prev, key10app: e.target.value})); }}></textarea>
                            </div>
                            <div className='careers-page-2024__text-field-wrapper'>
                                <div className='careers-page-2024__text-field-label'>EDUCATION</div>
                                <textarea className='careers-page-2024__text-field' placeholder='Please list your education: Institutions, Degrees, and graduation dates (you can include education that is in-progress)' value={application.key11app} onChange={(e) => {setApplication((prev) => ({ ...prev, key11app: e.target.value})); }}></textarea>
                            </div>
                            <div className='careers-page-2024__text-field-wrapper'>
                                <div className='careers-page-2024__text-field-label'>LINKS</div>
                                <textarea className='careers-page-2024__text-field' placeholder='Links to video or audio recordings of you playing' value={application.key20app} onChange={(e) => {setApplication((prev) => ({ ...prev, key20app: e.target.value})); }}></textarea>
                            </div>
                            <div className='careers-page-2024__text-field-wrapper'>
                                <div className='careers-page-2024__text-field-label'>WHAT MAKES YOU INTERESTED IN WORKING FOR {school.name.toUpperCase()}?</div>
                                <textarea className='careers-page-2024__text-field' placeholder='Why do you want to work with us' value={application.key12app} onChange={(e) => {setApplication((prev) => ({ ...prev, key12app: e.target.value})); }}></textarea>
                            </div>
                            <div className='careers-page-2024__check-wrapper' onClick={() => setApplication((prev) => ({...prev, key7app: !prev.key7app}))}>
                                {application.key7app ? <img alt='checkmark' className='careers-page-2024__checkmark' style={{backgroundColor: 'rgb(19, 174, 92)', borderRadius: '50%'}} src='./right.svg'/> : <img alt='empty-box' className='careers-page-2024__checkmark' src='./right-empty.svg' /> }
                                    <strong className='careers-page-2024__checkmark-title'>I have experience providing in-home lessons</strong>
                            </div>
                            <div className='careers-page-2024__check-wrapper' onClick={() => setApplication((prev) => ({...prev, key17app: !prev.key17app}))}>
                                {application.key17app ? <img alt='checkmark' className='careers-page-2024__checkmark' style={{backgroundColor: 'rgb(19, 174, 92)', borderRadius: '50%'}} src='./right.svg'/> : <img alt='empty-box' className='careers-page-2024__checkmark' src='./right-empty.svg' /> }
                                    <strong className='careers-page-2024__checkmark-title'>I am willing to undergo a background check, in accordance with local law/regulations.</strong>
                            </div>
                            <div className='careers-page-2024__check-wrapper' onClick={() => setApplication((prev) => ({...prev, key18app: !prev.key18app}))}>
                                {application.key18app ? <img alt='checkmark' className='careers-page-2024__checkmark' style={{backgroundColor: 'rgb(19, 174, 92)', borderRadius: '50%'}} src='./right.svg'/> : <img alt='empty-box' className='careers-page-2024__checkmark' src='./right-empty.svg' /> }
                                <strong className='careers-page-2024__checkmark-title'>I have a reliable vehicle.</strong>
                            </div>
                            <div className='careers-page-2024__check-wrapper' onClick={() => setApplication((prev) => ({...prev, key19app: !prev.key19app}))}>
                                {application.key19app ? <img alt='checkmark' className='careers-page-2024__checkmark' style={{backgroundColor: 'rgb(19, 174, 92)', borderRadius: '50%'}} src='./right.svg'/> : <img alt='empty-box' className='careers-page-2024__checkmark' src='./right-empty.svg' /> }
                                <strong className='careers-page-2024__checkmark-title'>I have a valid driver’s license.</strong>
                            </div>
                            <div className='careers-page-2024__text-field-wrapper'>
                                <div className='careers-page-2024__text-field-label'>WHERE DID YOU HEAR ABOUT US?</div>
                                <textarea className='careers-page-2024__text-field' onChange={(e) => setApplication((prev) => ({...prev, key21app: e.target.value}))} placeholder='How did you find us'></textarea>
                            </div>
                        </div>
                        {applicationSubmitted ? 
                            <div className='careers-page-2024__final-apply-button__wrapper'>
                                <div style={{color: 'green'}}>Application Received!</div>
                            </div>    
                        :
                        <div className='careers-page-2024__final-apply-button__wrapper'>
                            {submitting ? 
                                <div className='careers-page-2024__apply-now-button__loading'>Submitting Application...</div>
                            :
                            <div className='careers-page-2024__apply-now-button'>
                                <div className='careers-page-2024__apply-now-button__text' onClick={() => submitApplication()}>Submit Application</div>
                                <MdSend size={18} />
                            </div>
                            }
                        </div>
                        }
                    </div>
                </div>
                </>
    )
}
export default CareersPage2024;